import { useQuery } from "@tanstack/react-query";

import { QueryStatsTableRequestDto } from "@/shared/api";
import { useApi } from "@/shared/api/use-api";

type Params = {
  userId?: number;
  jobId?: string;
  pageNumber: number;
  pageSize: number;
  filters: QueryStatsTableRequestDto;
};

export const useQueryStatsTable = ({
  userId,
  jobId,
  pageNumber,
  pageSize,
  filters,
}: Params) => {
  const { statsControllerApi } = useApi();

  return useQuery({
    queryKey: [`queryStatsTable`, userId, jobId, pageNumber, pageSize, filters],
    queryFn: ({ signal }) => {
      return statsControllerApi.queryStatsTable(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        userId!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        jobId!,
        pageNumber,
        pageSize,
        filters,
        {
          signal,
        }
      );
    },
    enabled: !!jobId && !!userId,
    retry: 0,
  });
};
